import { Breadcrumbs } from '../translations-types';

const translations: Breadcrumbs = {
  organizationManagement: 'Organisation management',
  dashboard: 'Dashboard',
};

export default translations;
